// TODO: this should probably be housed somewhere more sophisticated than `window.`...
window.publish_statuses = {
	'unsubmitted': {
		index: 0,
		key: 'unsubmitted',
		icon: 'fas fa-file-user',
		color: 'orange',
		text: 'Not Submitted',
	},
	'returned_to_author': {
		index: 1,
		key: 'returned_to_author',
		icon: 'fas fa-file-user',
		color: 'orange',
		text: 'Returned to Author',
	},
	'submitted': {
		index: 2,
		key: 'submitted',
		icon: 'fas fa-file-export',
		color: 'pink',
		text: 'Submitted',
	},
	'under_review': {
		index: 3,
		key: 'under_review',
		icon: 'fas fa-file-magnifying-glass',
		color: 'purple',
		text: 'Under Review',
	},
	'ready_for_publication': {
		index: 4,
		key: 'ready_for_publication',
		icon: 'fas fa-file-check',
		color: 'blue',
		text: 'Ready for Publication',
	},
	'published': {
		index: 5,
		key: 'published',
		icon: 'fas fa-file-certificate',
		color: 'green',
		text: 'Published',
	},
}
window.publish_statuses[''] = window.publish_statuses.unsubmitted
window.publish_statuses[null] = window.publish_statuses.unsubmitted
window.get_publish_status_data = function(publish_status) {
	return (window.publish_statuses[publish_status] || window.publish_statuses.unsubmitted)
}

class Asset_Review {
	constructor(data, template, asset) {
		if (empty(data)) data = {}

		sdp(this, data, 'asset_review_id', 0)

		// set asset_type based on data, incoming asset, or default ''
		if (data.asset_type) this.asset_type = data.asset_type
		else if (asset) {
			if (!empty(asset.lesson_id)) this.asset_type = 'lesson'
			else this.asset_type = 'resource'
		} else this.asset_type = ''

		// set asset_id based on data, incoming asset, or default ''
		if (data.asset_id) this.asset_id = data.asset_id
		else if (asset) {
			if (!empty(asset.lesson_id)) this.asset_id = asset.lesson_id
			else this.asset_id = asset.resource_id
		} else this.asset_id = ''

		sdp(this, data, 'created_by', 0)	// 0 means this is the "default" review for an asset
		sdp(this, data, 'created_at', '')
		sdp(this, data, 'updated_at', '')

		sdp(this, data, 'max_total_score', 0)
		this.total_score = 0
		this.sections = {}

		// if we receive a template, use it to make sure the incoming sections conform with the template
		// We need to be careful here to handle the fact that elements of the review template are bound to change over time
		if (!empty(template)) {
			// here we calculate max_total_score on the fly, to make sure it is in synch with the current version of the template
			this.max_total_score = 0
			for (let section of template) {
				// skip sections not relevant for this asset type
				if (!section.asset_types.includes(this.asset_type)) continue

				// calculate max_total_score as we go
				this.max_total_score += Object.keys(section.scale)[Object.keys(section.scale).length - 1] * 1

				// determine local value for this section of the review. 
				let rs = {}

				// rso is data from the "original" review, if we have it
				let rso = (data.sections) ? data.sections[section.id] : null

				// score for the section is null if we don't have a value in the original review
				rs.score = rso?.score || null
				// for standards_alignment, if no standards are chosen, this is necessarily 0
				if (asset && section.id == 'standards_alignment' && asset.standards.length == 0) {
					rs.score = 0
				}

				// deal with section "criteria"
				if (section.criteria) {
					rs.criteria = {}
					for (let c of section.criteria) {
						if (rso?.criteria) rs.criteria[c.id] = rso.criteria[c.id]	// this could be null, but that's fine
						else rs.criteria[c.id] = null
					}
				}

				// deal with comments
				rs.comments = []
				if (rso?.comments) {
					for (let co of rso.comments) {
						rs.comments.push(new Asset_Review_Comment(co))
					}
				}
				
				this.sections[section.id] = rs
			}

		// else if we have incoming data, initialize just based on what we get from that data
		} else if (!empty(data.sections)) {
			for (let section_id in data.sections) {
				let rs = {}
				let rso = data.sections[section_id]
				rs.score = rso.score || null
				if (!empty(rso.criteria)) rs.criteria = object_copy(rso.criteria)
				else rs.criteria = {}

				rs.comments = []
				if (!empty(rso.comments)) {
					for (let co of rso.comments) {
						rs.comments.push(new Asset_Review_Comment(co))
					}
				}

				this.sections[section_id] = rs
			}
		}

		// compute the total score
		this.compute_total_score()
	}

	compute_total_score() {
		let ts = 0
		for (let section_id in this.sections) {
			let ss = this.sections[section_id].score
			if (ss !== null) ts += ss*1
		}
		this.total_score = ts
	}

	data_for_save() {
		// for now save everything
		return object_copy(this)
	}
}
window.Asset_Review = Asset_Review

class Asset_Review_Comment {
	constructor(data) {
		if (empty(data)) data = {}

		// // generate a new comment_id if needed
		// if (data.comment_id == 'new') {
		// 	this.comment_id = U.new_uuid()
		// } else if (!empty(data.comment_id)) {
		// 	this.comment_id = data.comment_id
		// } else {
		// 	console.warn('Review comment created with no comment_id')
		// }

		sdp(this, data, 'comment_id', '')
		sdp(this, data, 'parent_comment_id', '')
		sdp(this, data, 'author_email', '')
		sdp(this, data, 'author_name', '')
		sdp(this, data, 'author_id', '')
		sdp(this, data, 'text', '')
		sdp(this, data, 'created_at', 0)	// timestamp
	}

	async set_created_at() {
		// TODO: get server timestamp instead of using client timestamp, which is dependent on the time being set correctly
		this.created_at = Math.floor(Date.now() / 1000)
	}

	async set_new_id() {
		this.comment_id = U.new_uuid()
	}
}
window.Asset_Review_Comment = Asset_Review_Comment
